import { Component, Input } from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-planning-poker-annotation-header",
  templateUrl: "./planning-poker-annotation-header.component.html",
  styleUrls: ["./planning-poker-annotation-header.component.scss"],
})
export class PlanningPokerAnnotationHeaderComponent {
  @Input() annotation: any;
  env: any = environment;

  constructor() {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/planning-poker-annotation-header/planning-poker-annotation-header.component.ts